<template>
    <div id="show">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>
        <div class="ui horizontal divider">
            <h3><i class="user icon"></i>
                {{ $t('ui.pages.operations.content') }}
            </h3>
        </div>

        <div class="ui horizontal segments">
            <div class="ui segment">
                <div class="ui divided items">
                    <div class="item">
                        <div class="content">
                            <div class="header">{{ $t('models.attributes.operations.number') }}</div>
                            <div class="description">
                                {{ operation.number }}
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="content">
                            <div class="header">{{ $t('models.attributes.operations.created_at') }}</div>
                            <div class="description">
                                {{ human_datetime(operation.created_at) }}
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="content">
                            <div class="header">{{ $t('models.attributes.operations.status') }}</div>
                            <div class="description">
                                <span v-if="operation.is_done">
                                    <!-- 已完成 -->
                                    {{ $t('models.attributes.operations.is_done_true') }}
                                </span>
                                <span v-else>
                                    <!-- 未完成 -->
                                    {{ $t('models.attributes.operations.is_done_false') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ui segment">
                <div class="ui divided items">
                    <div class="item">
                        <div class="content">
                            <div class="header">{{ $t('models.attributes.operations.number') }}</div>
                            <div class="description">
                                {{ operation.number }}
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="content">
                            <div class="header">{{ $t('models.attributes.operations.created_at') }}</div>
                            <div class="description">
                                {{ human_datetime(operation.created_at) }}
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="content">
                            <div class="header">{{ $t('models.attributes.operations.status') }}</div>
                            <div class="description">
                                <span v-if="operation.is_done">
                                    <!-- 已完成 -->
                                    {{ $t('models.attributes.operations.is_done_true') }}
                                </span>
                                <span v-else>
                                    <!-- 未完成 -->
                                    {{ $t('models.attributes.operations.is_done_false') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="is_initialized">
            <div v-if="is_loading" class="ui active centered inline loader"></div>
            <table class="ui fixed table blue" v-else-if="operation.identity">
                <thead>
                    <tr>
                        <th :class="style.width < 767 ? '' : 'right aligned'" style="text-overflow: initial;">
                            {{ operation.number }}
                        </th>
                        <th colspan="4">

                        </th>
                        <th>
                            {{ human_datetime(operation.created_at) }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            {{ $t('models.attributes.operations.status') }}
                        </td>
                        <td colspan="5">
                            <div class="ui checkbox">
                                <input type="checkbox" v-model="operation.is_done" id="is_done">
                                <label for="is_done" class="pointer">
                                    <span v-if="operation.is_done">
                                        <!-- 已完成 -->
                                        {{ $t('models.attributes.operations.is_done_true') }}
                                    </span>
                                    <span v-else>
                                        <!-- 未完成 -->
                                        {{ $t('models.attributes.operations.is_done_false') }}
                                    </span>
                                </label>
                            </div>
                            <!-- <div class="ui checkbox">
                                <input type="checkbox" v-model="operation.is_canceled">
                                <label>
                                    <span v-if="operation.is_canceled">{{ $t('ui.general.cancel') }}</span>
                                    <span v-else>未取消</span>
                                </label>
                            </div> -->
                        </td>
                    </tr>
                    <tr v-if="operation.is_canceled">
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            取消原因
                        </td>
                        <td class="ui form" colspan="5">
                            <textarea v-model="operation.cancel_reason"></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 進&emsp;&emsp;度 -->
                            {{ $t('ui.pages.operations.schedule') }}
                        </td>
                        <td colspan="5">
                            <div class="ui indicating progress" :data-value="done_core_waybills.length" :data-total="operation.core_waybills.length" v-progress>
                                <div class="bar">
                                    <div class="progress"></div>
                                </div>
                                <div class="label">{{ done_core_waybills.length }} / {{ operation.core_waybills.length }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 分配站點 -->
                            {{ $t('models.attributes.operations.station') }}
                        </td>
                        <td class="ui form" colspan="5" style="overflow: visible;">
                            <select class="ui dropdown" v-dropdown v-model="operation.station_identity" ref="station_identity">
                                <option value="">{{ $t('ui.general.please_select') }}</option>
                                <option v-for="station in $store.state.provider.stations" :value="station.identity">{{ station.name }}</option>
                            </select>
                            <button class="ui basic icon button"
                                @click="
                                    operation.station_identity = null;
                                    $($refs.station_identity).dropdown('clear');
                                ">
                                <i class="remove icon"></i>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 分配人員 -->
                            {{ $t('models.attributes.operations.staffs') }}
                        </td>
                        <td class="ui form" colspan="5" style="overflow: visible;">
                            <select class="ui dropdown" multiple="" v-dropdown v-model="operation.staff_identities" ref="staff_identities">
                                <option value="">{{ $t('ui.general.please_select') }}</option>
                                <option v-for="staff in $store.state.provider.operations_module.staffs" :value="staff.identity">{{ staff.name }}</option>
                            </select>
                            <button class="ui basic icon button"
                                style="vertical-align: bottom;"
                                @click="
                                    operation.staff_identities = null;
                                    $($refs.staff_identities).dropdown('clear');
                                ">
                                <i class="remove icon"></i>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 您的備註 -->
                            {{ $t('models.attributes.operations.your_note') }}
                        </td>
                        <td class="ui form" colspan="5">
                            <textarea v-model="operation.provider_note"></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 客&emsp;&emsp;戶 -->
                            {{ $t('models.attributes.operations.customer') }}
                        </td>
                        <td class="ui form" colspan="5" style="overflow: visible;">
                            <div class="ui selection dropdown" v-dropdown ref="customer_identity">
                                <input type="hidden" v-model="operation.customer_identity">
                                <i class="dropdown icon"></i>
                                <div class="default text">
                                    {{ $t('ui.general.please_select') }}
                                </div>
                                <div class="menu">
                                    <div
                                        class="item"
                                        :data-value="customer.identity"
                                        v-for="customer in customers"
                                        @click="
                                        selected_customer = customer;
                                        operation.customer_identity = customer.identity;
                                        operation.contract_identity = customer.contracts[0].identity;">
                                            {{ customer.company_name }}
                                    </div>
                                </div>
                            </div>
                            <div v-if="selected_customer" style="display: inline-block;">
                                <select v-dropdown v-model="operation.contract_identity">
                                    <option value>
                                        {{ $t('ui.general.please_select') }}
                                        <!-- 合約 -->
                                        {{ $t('ui.pages.operations.contract') }}
                                    </option>
                                    <option v-for="contract in selected_customer.contracts" :contract="contract" :value="contract.identity">{{ contract.name }}</option>
                                </select>
                            </div>
                            <button class="ui basic icon button"
                                @click="
                                    selected_customer = null;
                                    operation.customer_identity = null;
                                    operation.contract_identity = null;
                                    $($refs.customer_identity).dropdown('clear');
                                ">
                                <i class="remove icon"></i>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 客戶備註 -->
                            {{ $t('models.attributes.operations.customer_note') }}
                        </td>
                        <td colspan="5">
                            {{ operation.customer_note || '-' }}
                        </td>
                    </tr>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 託運文件 -->
                            {{ $t('models.attributes.operations.file') }}
                        </td>
                        <td colspan="5">
                            <a :href="operation.original_file_url">{{ operation.original_file_name }}</a>
                        </td>
                    </tr>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 印出運單標籤 -->
                            {{ $t('ui.pages.operations.print_coew_waybill_labels') }}
                        </td>
                        <td colspan="5" style="overflow: visible;">
                            <CoreWaybillsLabelSvg
                                :numbers="label_numbers"
                                :authentication_token="token"
                                :scope="'provider'"
                                :printing_type="printing_type_grouped_core_waybills"
                                :channel="print_label_channel"
                                :is_show_input="false"
                            >
                            </CoreWaybillsLabelSvg>
                        </td>
                    </tr>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 印出託運總表 -->
                            {{ $t('ui.pages.operations.print_coew_waybill_checklist') }}
                        </td>
                        <td colspan="5">
                            <!-- $store.state.provider.node.company_short_name + '託運總表'" -->
                            <OrderSummary
                                :channel_name="'my_order_summaray'"
                                :default_search_params="{
                                    pagination: false,
                                    operation: {
                                        identity: operation.identity
                                    },
                                }"
                                :title="$t('ui.pages.operations._name_operation_list',{
                                    name: $store.state.provider.node.company_short_name
                                })"
                                :sub_title="$store.state.provider.node.website_url"
                                :customer_service_hotline="$store.state.provider.node.customer_service_hotline"
                                :logistician="{name: '9999999 配送人員'}"
                                :logo_url="'/images/' + $store.state.provider.node.company_en_name.replace(/(?:^|\.|\s?)([A-Z])/g, function (x,y){return '_' + y.toLowerCase()}).replace(/^_/, '') + '_logo.jpg'"
                                :show_buttons="true"
                                :show_contents="false"
                                :scope="'provider'"
                                >
                            </OrderSummary>

                        </td>
                    </tr>
                    <tr v-if="show_receipts">
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            <!-- 印出簽收單 -->
                            {{ $t('ui.pages.operations.print_receipt') }}
                        </td>
                        <td colspan="5" style="overflow: visible;">
                            <!-- :title="node.company_short_name + '客戶簽收單'" -->
                            <Receipts
                                style="display: inline-block;"
                                :show_buttons="true"
                                :buttons_type="style.width >= 550 ? 'button' : 'select'"
                                :default_search_params="{
                                    operation_identity: operation.identity,
                                    pagination: false,
                                    materials: 'Waybill',
                                }"
                                :logo_url="'/images/' + node.company_en_name.replace(/(?:^|\.|\s?)([A-Z])/g, function (x,y){return '_' + y.toLowerCase()}).replace(/^_/, '') + '_logo.jpg'"
                                :title="$t('ui.pages.operations._name_customer_receipt',{
                                    name: node.company_short_name
                                })"
                                :sub_title="node.website_url"
                                :customer_service_hotline="node.customer_service_hotline"
                                :logistician="current_staff"
                                :location="''"
                                >
                            </Receipts>
                        </td>
                    </tr>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            {{ $t('ui.general.operate') }}
                        </td>
                        <td colspan="5">
                            <button class="ui basic positive button" @click.prevent="update_operation()">
                                {{ $t('ui.general.update') }}
                            </button>
                            <button class="ui basic negative button" @click.prevent="delete_operation()">
                                {{ $t('ui.general.delete') }}
                            </button>
                            <button class="ui basic orange button" v-if="!operation.is_done" @click.prevent="done_operation()">
                                {{ $t('ui.general.complete') }}
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td :class="style.width < 767 ? '' : 'right aligned'">
                            {{ $t('models.core_waybills') }} {{ $t('ui.general.operate') }}
                        </td>
                        <td colspan="5" style="overflow: visible;">
                            <button class="ui basic labeled icon button"
                                style="padding-left: 3.07142857em!important;"
                                v-if="core_waybills_intermodal.can_run_items.length != 0"
                                :data-tooltip="_.map(core_waybills_intermodal.can_run_items, 'number').toString() + $t('ui.pages.operations.core_waybill_process_intermodal.total__number__can_run', {
                                    number: core_waybills_intermodal.can_run_items.length
                                })"
                                :data-position="'bottom center'"
                                :class="(core_waybills_intermodal.is_processing) ? 'orange' : 'positive'"
                                @click.prevent="core_waybills_process_intermodal_job()">
                                <!-- :class="(intermodal_contract_number_count != 0) ? 'positive' : 'negative' " -->
                                <i class="basic icon"
                                    style="background: none;"
                                    :class="(core_waybills_intermodal.is_processing) ? 'spinner' : 'play'"
                                    >
                                </i>
                                <!-- 全部聯運 -->
                                {{ $t('ui.pages.operations.core_waybill_process_intermodal.all') }}
                            </button>
                            <button class="ui basic negative labeled icon button"
                                style="padding-left: 3.07142857em!important;"
                                :data-tooltip="$t('ui.pages.operations.core_waybill_process_intermodal.no_any_can_run')"
                                :data-position="'right center'"
                                v-popup
                                v-else>
                                <i class="basic dont icon" style="background: none;"></i>
                                <!-- 全部聯運 -->
                                {{ $t('ui.pages.operations.core_waybill_process_intermodal.all') }}
                            </button>
                            <small>
                                <!-- 聯運的運單必須包含 聯運合約號 和 追蹤號碼 -->
                                {{ $t('ui.pages.operations.core_waybill_process_intermodal.note') }}
                            </small>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="6" class="x_scrollable">
                            <CoreWaybills
                                :default_search_params="{
                                    operation_identity: operation.identity,
                                    include_is_deleted: true,
                                }"
                                :scope="'provider'"
                                :show_delete_button="true"
                                :show_update_button="true"
                                :show_export_csv_button="true"
                                :csv_file_name="operation.number"
                                :columns="core_waybill_columns"
                                :updater_columns="updater_columns"
                                >
                            </CoreWaybills>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="ui segment" v-if="operation.identity">
                <Comments :commentable_type="'Operation'" :commentable_identity="operation.identity" :scope="'provider'"></Comments>
            </div>
        </div>
        <div class="ui active inverted dimmer" v-else>
            <div class="ui text loader">{{ $t('ui.general.initializing') }}</div>
        </div>
    </div>
</template>

<script>
import CoreWaybillsLabelSvg from "@toolbox/core_waybills_label_svg/main.vue"
import OrderSummary from "@toolbox/order_summary/main.vue"
import Receipts from "@toolbox/receipts/main.vue"
import Comments from "@toolbox/bulletin_board/comments.vue"
import CoreWaybills from "@toolbox/core_waybills/main.vue"
import ErrorMessages from '@toolbox/error_box/main.vue'
export default {
    name: "EditOperation",
    props: {
    },
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            core_waybills_intermodal: {
                is_processing: false,
                can_run_items: []
            },
            operation: {},
            selected_customer: null,
            errors: [],
            print_label_channel: "operation_print_label_channel",
            core_waybill_columns: [
                {
                    input_type: "materials",
                    display_type: "material",
                    name: "materials",
                    // human_name: "類型",
                    human_name: this.$t('models.materials'),
                },
                {
                    input_type: "text",
                    display_type: "text",
                    name: "number",
                    // human_name: "單號",
                    human_name: this.$t('models.attributes.core_waybills.number'),
                },
                {
                    input_type: "text",
                    display_type: "text",
                    name: "original_number",
                    // human_name: "原單號",
                    human_name: this.$t('models.attributes.core_waybills.original_number'),
                },
                {
                    input_type: "text",
                    display_type: "text",
                    name: "tracking_number",
                    // human_name: "追蹤號",
                    human_name: this.$t('models.attributes.core_waybills.tracking_number'),
                },
                {
                    input_type: "text",
                    display_type: "text",
                    name: "sender_name",
                    // human_name: "寄件人姓名",
                    human_name: this.$t('models.attributes.core_waybills.sender_name'),
                },
                {
                    input_type: "text",
                    display_type: "text",
                    name: "consignee_name",
                    // human_name: "收件人姓名",
                    human_name: this.$t('models.attributes.core_waybills.consignee_name'),
                },
                {
                    input_type: "text",
                    display_type: "text",
                    name: "consignee_phone",
                    // human_name: "收件人電話",
                    human_name: this.$t('models.attributes.core_waybills.consignee_phone'),
                },
                {
                    input_type: "number",
                    display_type: "text",
                    name: "weight_in_kilo",
                    // human_name: "重量",
                    human_name: this.$t('models.attributes.core_waybills.weight_in_kilo'),
                },
                {
                    input_type: "number",
                    display_type: "text",
                    name: "collection",
                    // human_name: "代收貨款",
                    human_name: this.$t('models.attributes.core_waybills.collection'),
                },
                {
                    input_type: null,
                    display_type: "status",
                    name: "latest_status",
                    // human_name: "貨況",
                    human_name: this.$t('models.attributes.core_waybills.latest_status'),
                },
                {
                    input_type: "checkbox",
                    display_type: "boolean",
                    name: "is_done",
                    // human_name: "完成",
                    human_name: this.$t('ui.pages.core_waybills.done'),
                    default_value: false,
                },
            ],
            updater_columns: [
                {
                    toggle: false,
                    // header_text: "原單號",
                    header_text: this.$t('models.attributes.core_waybills.original_number'),
                    attribute_name: "original_number",
                    type: "text",
                },
                {
                    toggle: false,
                    // header_text: "追蹤號碼(聯運單號)",
                    header_text: this.$t('models.attributes.core_waybills.tracking_number'),
                    attribute_name: "tracking_number",
                    type: "text",
                },
                {
                    toggle: false,
                    // header_text: "寄件人姓名",
                    header_text: this.$t('models.attributes.core_waybills.sender_name'),
                    attribute_name: "sender_name",
                    type: "text",
                },
                {
                    toggle: false,
                    // header_text: "寄件人地址",
                    header_text: this.$t('models.attributes.core_waybills.sender_address'),
                    attribute_name: "sender_address",
                    type: "text",
                },
                {
                    toggle: false,
                    // header_text: "寄件人電話",
                    header_text: this.$t('models.attributes.core_waybills.sender_phone'),
                    attribute_name: "sender_phone",
                    type: "text",
                },
                {
                    toggle: false,
                    // header_text: "收件人姓名",
                    header_text: this.$t('models.attributes.core_waybills.consignee_name'),
                    attribute_name: "consignee_name",
                    type: "text",
                },
                {
                    toggle: false,
                    // header_text: "收件人地址",
                    header_text: this.$t('models.attributes.core_waybills.consignee_address'),
                    attribute_name: "consignee_address",
                    type: "text",
                },
                {
                    toggle: false,
                    // header_text: "收件人電話",
                    header_text: this.$t('models.attributes.core_waybills.consignee_phone'),
                    attribute_name: "consignee_phone",
                    type: "text",
                },
                {
                    toggle: false,
                    // header_text: "重量",
                    header_text: this.$t('models.attributes.core_waybills.weight_in_kilo'),
                    attribute_name: "weight_in_kilo",
                    type: "number",
                },
                {
                    toggle: false,
                    // header_text: "代收貨款",
                    header_text: this.$t('models.attributes.core_waybills.collection'),
                    attribute_name: "collection",
                    type: "number",
                },
            ]
        }
    },
    watch: {
        '$route' (to, from) {
            if (to != from) {
                this.init()
            }
        },
        'operation.core_waybills' (value) {
            if (value) {
                let can_run_items = _.filter(value, (core_waybill) => {
                    return core_waybill.intermodal_contract_number != null && core_waybill.tracking_number != null
                }) || []
                this.$set(this.core_waybills_intermodal, 'can_run_items', can_run_items)
            }
        }
    },
    created() {
        this.init()
    },
    mounted() {
    },
    computed: {
        current_store: (instance) => instance.$store.state.provider.operations_module,
        intermodal_contract_number_count() {
            let result = _.map(this.operation.core_waybills, 'intermodal_contract_number') || []
            return _.compact(result).length || 0
        },
        material_grouped_core_waybills() {
            return _.groupBy(this.operation.core_waybills, 'material.class_name')
        },
        label_numbers() {
            let label_number_objects = []
            _.forEach(this.material_grouped_core_waybills.Waybill, (e) => {
                if (!isNaN(parseInt(e.note_2))) {
                    for (let i = 1; i <= parseInt(e.note_2); i++) {
                        label_number_objects.push(
                            {
                                number: e.number,
                                count: parseInt(e.note_2),
                                serial: i
                            }
                        )
                    }
                } else {
                    label_number_objects.push(
                        {
                            number: e.number,
                            count: 1,
                            serial: 1
                        }
                    )
                }
            })
            _.forEach(this.material_grouped_core_waybills.Goods, (e) => {
                if (!isNaN(parseInt(e.note_2))) {
                    for (let i = 1; i <= parseInt(e.note_2); i++) {
                        label_number_objects.push(
                            {
                                number: e.number,
                                count: parseInt(e.note_2),
                                serial: i
                            }
                        )
                    }
                } else {
                    label_number_objects.push(
                        {
                            number: e.number,
                            count: 1,
                            serial: 1
                        }
                    )
                }
            })
            return label_number_objects
        },
        printing_type_grouped_core_waybills() {
            let result = _.groupBy(this.operation.core_waybills, 'label_type')
            let key_names = Object.keys(result)
            return key_names[0] != "undefined" ? key_names[0] : null
        },
        token() {
            return localStorage.getItem("authentication_token")
        },
        style() {
            return this.$store.state.style
        },
        customers() {
            return this.$store.state.provider.customers
        },
        node() {
            return this.$store.state.provider.node
        },
        current_staff() {
            return this.$store.state.provider.current_staff
        },
        done_core_waybills() {
            return _.filter(this.operation.core_waybills, core_waybill => {
                return core_waybill.is_done == true
            })
        },
        current_service_name() {
            return this.$store.state.provider.node.service_name
        },
        show_receipts() {
            return ["neuron", "neuron_premium"].includes(this.current_service_name)
        },
    },
    methods: {
        async init() {
            try {
                await new Promise(resolve => {
                    this.is_initialized = false
                    resolve()
                })
                await this.fetch_operation()
                await new Promise(resolve => {
                    if (this.operation.customer_identity) {
                        this.selected_customer = _.find(this.customers, e => {
                            return e.identity == this.operation.customer_identity
                        })
                    }
                    resolve()
                })
                await new Promise(resolve => {
                    this.is_initialized = true
                    resolve()
                })
            } catch (e) {
                switch (e) {
                    default:
                    console.log("init error: ")
                    console.log(e)
                }
            } finally {

            }
        },
        fetch_operation() {
            this.is_loading = true
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_operation).parse(
                {"operation_identity": this.$route.params.identity},
            )
            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.operation = response.data.operation
                    } else if (response.data.status == "failure") {
                        return Promise.reject(response.data)
                    }
                })
                .catch(error => {
                    if (error.response) {
                        switch (error.response.status) {
                            default:
                            this.errors.push(error.response.status + ' ' + error.response.statusText)
                        }
                        // this.$noty.error('取得 訂單 失敗: ' + error.response.status + ' ' + error.response.statusText)
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('models.operations'),
                                reason: ': ' + error.response.status + ' ' + error.response.statusText
                            })
                        )
                    } else if (error.errors) {
                        this.errors.push(error.errors)
                        // this.$noty.error('取得 訂單 失敗: ' + error.errors)
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('models.operations'),
                                reason: ': ' + error.errors
                            })
                        )
                    } else {
                        this.errors.push(this.$t('ui.general.server_offline'))
                        this.$noty.error(this.$t('ui.general.server_offline'))
                    }
                    // return Promise.reject(error)
                })
                .finally(() => {
                    this.is_loading = false
                })
        },
        done_operation() {
            if (confirm("確定完成此訂單？")) {
                this.is_loading = true
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_operation_done).parse(
                    {"operation_identity": this.$route.params.identity},
                )

                axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }}).then(response => {
                    if (response.data.status == "success") {
                        this.$noty.success(
                            this.$t('ui.notifications.success.update__name', {
                                name: this.$t('models.operations')
                            })
                        )
                        if (this.current_store.pagination.current_page) {
                            this.$router.push({name: 'provider_operations', query: { page: this.current_store.pagination.current_page }});
                        } else {
                            this.$router.push({name: 'provider_operations'});
                        }
                    } else {
                        this.$noty.error(
                            this.$t('ui.notifications.error.update__name', {
                                name: this.$t('models.operations'),
                                reason: ': ' + response.data.errors
                            })
                        )
                        this.errors = response.data.errors
                    }
                })
                .catch(error => {
                    console.log(error.response)
                    if (!error.response) {
                        this.$noty.error(
                            this.$t('ui.general.network_abnormality')+": "+
                            this.$t('ui.general.server_offline')
                        )
                    } else {
                        this.$noty.error(
                            this.$t('ui.general.network_abnormality') + ': ' + error.response.data.errors
                        )
                    }
                })
                .finally(() => {
                    this.is_loading = false
                })
            }
        },
        update_operation() {
            this.is_loading = true
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_operation_update).parse(
                {"operation_identity": this.$route.params.identity},
            )
            var params = this.operation
            delete params["identity"]
            delete params["number"]
            delete params["created_at"]
            delete params["file_name"]
            delete params["file_url"]
            delete params["customer_note"]
            delete params["instantiate_note"]
            delete params["is_instantiated"]
            delete params["is_operable"]
            delete params["is_operated"]
            delete params["is_ready"]
            delete params["core_waybills"]
            delete params["customer_node"]
            delete params["station"]
            delete params["staffs"]
            delete params["operation_identity"]
            axios.post(url, params, { headers: { Authorization: localStorage.getItem("authentication_token") }}).then(response => {
                if (response.data.status == "success") {
                    this.init()
                    // this.$noty.success("訂單更新成功")
                    this.$noty.success(
                        this.$t('ui.notifications.success.create__name', {
                            name: this.$t('models.operations')
                        })
                    )
                } else {
                    // this.$noty.error("訂單更新失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.update__name', {
                            name: this.$t('models.operations'),
                            reason: ': ' + response.data.errors
                        })
                    )
                    this.errors = response.data.errors
                }
            })
            .catch(error => {
                console.log(error)
                if (!error.response) {
                    // Network Error
                    this.$noty.error(
                        this.$t('ui.general.network_abnormality')+": "+
                        this.$t('ui.general.server_offline')
                    )
                } else {
                    this.$noty.error(
                        this.$t('ui.general.network_abnormality')+': ' +
                        error.response.status + error.response.data
                    )
                }
            })
            .finally(() => {
                this.is_loading = false
            })
        },
        delete_operation() {
            if (confirm(
                this.$t('ui.pages.operations.delete_help') + '\n' +
                this.$t('ui.notifications.warning.are_you_sure_to_delete_it')
            )) {
                this.is_loading = true
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_operation_delete).parse(
                    {"operation_identity": this.$route.params.identity},
                )
                axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }}).then(response => {
                    if (response.data.status == "success") {
                        this.$router.push({name: 'provider_operations'})
                        // this.$noty.success("訂單刪除成功")
                        this.$noty.success(
                            this.$t('ui.notifications.success.delete__name', {
                                name: this.$t('models.operations')
                            })
                        )
                    } else {
                        return Promise.reject(response.data)
                    }
                })
                .catch(error => {
                    if (error.response) {
                        switch (error.response.status) {
                            default:
                            this.errors.push(error.response.status + ' ' + error.response.statusText)
                        }
                        // this.$noty.error('刪除訂單失敗: ' + error.response.status + ' ' + error.response.statusText)
                        this.$noty.error(
                            this.$t('ui.notifications.error.delete__name', {
                                name: this.$t('models.operations'),
                                reason: ': ' + error.response.status + ' ' + error.response.statusText
                            })
                        )
                    } else if (error.errors) {
                        // this.$noty.error('刪除訂單失敗: ' + error.errors)
                        this.$noty.error(
                            this.$t('ui.notifications.error.delete__name', {
                                name: this.$t('models.operations'),
                                reason: ': ' + response.data.errors
                            })
                        )
                        this.errors = response.data.errors
                    } else {
                        this.errors.push(this.$t('ui.general.server_offline'))
                        this.$noty.error(this.$t('ui.general.server_offline'))
                    }
                    return Promise.reject(error)
                })
                .finally(() => {
                    setTimeout(() => {
                        this.is_loading = false
                    }, 300)
                })
            }
        },
        /**
         * ========================================================================
         * CoreWaybills
         * ========================================================================
        **/
        core_waybills_process_intermodal_job() {
            try {
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_operation_core_waybills_process_intermodal_job).parse({
                    operation_identity: this.operation.identity
                })
                let data = {
                    core_waybill_identities: _.map(this.core_waybills_intermodal.can_run_items, 'identity')
                }

                return axios.post(url, data, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                    .then(response => {
                        if (response.data.status == "success") {
                            // this.$noty.success("聯運執行中，請等候完成通知")
                            this.$noty.success(
                                this.$t('ui.pages.operations.core_waybill_process_intermodal.running')
                            )
                        } else {
                            // this.$noty.error("聯運執行失敗")
                            this.$noty.error(
                                this.$t('ui.notifications.error.fetch__name', {
                                    name: this.$t('ui.pages.operations.core_waybill_process_intermodal.run'),
                                    reason: ''
                                })
                            )
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        // this.$noty.error("聯運執行錯誤")
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('ui.pages.operations.core_waybill_process_intermodal.run'),
                                reason: ': ' +this.$t('ui.general.network_abnormality')+','+ error.response.status
                            })
                        )
                    })
            } catch (e) {
                console.log('//// core_waybills_process_intermodal_job /////')
                console.log(e)
            } finally {
                this.$set(this.core_waybills_intermodal, 'is_processing', false)
            }
        }
    },
    components: {
        CoreWaybillsLabelSvg,
        OrderSummary,
        Comments,
        Receipts,
        CoreWaybills,
        ErrorMessages,
    }
}
</script>

<style scoped>
</style>
